import React from "react";
import "../all css/heroaboutussection.css";
import LeaderPart from "./LeaderPart";
import Media from "react-media";
const text_img = require("../../assets/text_for_leader.svg");
const leader_circle = require("../../assets/aboutexplore/leader_section_img.png");
const leader_img = require("../../assets/Leader/Puja.jpg");
const leader_img1 = require("../../assets/Leader/Varun.jpg");
const leader_img2 = require("../../assets/Leader/Vineet.jpg");
const leader_img3 = require("../../assets/Leader/Ahsan.jpg");

function HeroSectionAboutUs(props) {
  return (
    <>
      <section className="hero_about_us_section_main_container">
        <div className="hero_about_us_section_under_main_container">
          <div className="hero_about_us_text_img_container">
            <div className="hero_about_us_left_container">
              <div className="text_img_container wow bounceInLeft">
                <img
                  className="text_img"
                  alt="text_img"
                  src={text_img.default}
                />
              </div>
            </div>
            <div className="hero_about_us_left_container"></div>
          </div>
        </div>
      </section>
      <div className="hero_yellow_main_line_container">
        <div className="yellow_line_container">
          <div className="yellow_container_self" />
          <div className="hero_under_yellow_line_contianer">
            <div className="leader_circle_container wow rollIn center">
              <img
                src={leader_circle}
                alt="leader"
                className="leader_circle_self"
              />
            </div>
            <div className="leaders_main_container">
              <div className="all_leader_container">
                <div className="left_leader_side_container">
                  <LeaderPart
                    leaderImg={leader_img}
                    leaderName="PUJA SALUJA"
                    leaderSubname="FOUNDER & CEO"
                    personInfo="Puja Saluja is an entrepreneur who zealously pursues ideas and brings them to fruition. During her decade and a half career, she has been instrumental in helping millions of Indian students to study, live and work abroad. Her commitment, enthusiasm, strong business networking capabilities, and vision ensure continuous growth for the organization."
                    fbUserLink="http://www.fb.com"
                    linkUserLink="https://www.linkedin.com/in/pujasaluja"
                    twitterUserLink="https://www.twitter.com"
                    duration="2s"
                    delay="0.5s"
                  />
                  <Media query="(max-width: 767px)">
                    {(matches) => {
                      return matches ? (
                        <LeaderPart
                          leaderImg={leader_img1}
                          leaderName="VARUN KHOSLA"
                          leaderSubname="CHAIRMAN"
                          personInfo="Varun Khosla advocates collaborative thinking for advancing knowledge and works with specialists in Human Resources Consultancies. He believes that extraordinary results can be achieved with the right amount of inspiration, encouragement, and understanding of the people and processes."
                          fbUserLink="http://www.fb.com"
                          linkUserLink="https://www.linkedin.com/in/khoslavarun"
                          twitterUserLink="https://www.twitter.com"
                          duration="2s"
                          delay="1.5s"
                        />
                      ) : (
                        <LeaderPart
                          leaderImg={leader_img3}
                          leaderName="AHSAN KHAN"
                          leaderSubname="CO-FOUNDER & COO"
                          personInfo="With 20+ years of experience in various sectors such as cement, construction materials. Insurance, real estate & education, Ashan has erstwhile worked in ICICI, HDFC & TATA groups and successfully held positions like Associate Director and Sr. VP. He brings along his wide experience of managing large direct teams."
                         
                          linkUserLink="https://www.linkedin.com/in/connect2ahsan/"
                          twitterUserLink="https://www.twitter.com"
                          duration="2s"
                          delay="1.0s"
                        />
                      );
                    }}
                  </Media>

                  <Media query="(max-width: 767px)">
                    {(matches) => {
                      return matches ? (
                        <LeaderPart
                          leaderImg={leader_img3}
                          leaderName="AHSAN KHAN"
                          leaderSubname="CO-FOUNDER & COO"
                          personInfo="With 20+ years of experience in various sectors such as cement, construction materials. Insurance, real estate & education, Ashan has erstwhile worked in ICICI, HDFC & TATA groups and successfully held positions like Associate Director and Sr. VP. He brings along his wide experience of managing large direct teams."
                          linkUserLink="https://www.linkedin.com/in/connect2ahsan/"
                          twitterUserLink="https://www.twitter.com"
                          duration="2s"
                          delay="1.0s"
                        />
                      ) : null;
                    }}
                  </Media>
                </div>
                <div className="right_leader_side_container">
                  <Media query="(max-width: 767px)">
                    {(matches) => {
                      return matches ? null : (
                        <LeaderPart
                          leaderImg={leader_img1}
                          leaderName="VARUN KHOSLA"
                          leaderSubname="CHAIRMAN"
                          personInfo="Varun Khosla advocates collaborative thinking for advancing knowledge and works with specialists in Human Resources Consultancies. He believes that extraordinary results can be achieved with the right amount of inspiration, encouragement, and understanding of the people and processes."
                          fbUserLink="http://www.fb.com"
                          linkUserLink="https://www.linkedin.com/in/khoslavarun"
                          twitterUserLink="https://www.twitter.com"
                          duration="2s"
                          delay="1.5s"
                        />
                      );
                    }}
                  </Media>

                  <LeaderPart
                    leaderImg={leader_img2}
                    leaderName="VINEET MEHROTRA"
                    leaderSubname="President- India & Global Operations"
                    personInfo="Vineet Mehrotra is a senior management professional with a global working experience of 31 years, having worked in India for 17+ years as well as across the Gulf Region for 14 years . Worked in
                    the capacities of Advisory Board Member/ Chief Executive Officer/Vice President/Group Director/General Manager
                    managing varied roles for Profit Centre Head, Head of Business/Strategic Planning &
                    Implementation &  overall stakeholder Management portfolios , managing large teams of 300+ "
                    fbUserLink="https://www.facebook.com/vineetmeh"
                    linkUserLink="https://www.linkedin.com/in/vineet-mehrotra-ab3632218"
                    twitterUserLink="https://twitter.com/vinmeh1602?t=otMpOtl_N_IOeeHk0Kt8RQ&s=09"
                    duration="2s"
                    delay="2.0s"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HeroSectionAboutUs;
